import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-invite-member-without-access-box',
  templateUrl: './invite-member-without-access-box.component.html',
  styleUrls: ['./invite-member-without-access-box.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IconComponent, TranslatePipe],
})
export class InviteMemberWithoutAccessBoxComponent {
  public inviteClick = output<void>();
}
